/**
 * @param {String} type - The type to display either SMS/Email
 * @param {*} name - The name of the folder being used
 * @returns {String}
 * @description Returns a simple title for the SMS/Email templates
 * based on the type of template being used, and the currently
 * selected folder
 */
export function setNameFromFolders(type, name) {
  if (name === 'all') {
    return `All ${type} Templates`
  } else {
    return `${name} Templates`
  }
}

/**
 * @param {Number} number
 * @param {Object} options
 * @param {String} format
 * @return {Number}
 */
export function formatNumber(number, options = {}, format = 'en-IN') {
  return new Intl.NumberFormat(format, options).format(number)
}
